<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html lang="en">
<head>
  <style type="text/css">
    /*html, body {
      background: #e5e5e5;
      text-align: center;
    }*/

    /* start basic spinner styles*/

    div.spinner {
      position: relative;
      width: 100px;
      height: 100px;
      display: inline-block;
    }

      div.spinner div {
        width: 12%;
        height: 26%;
        background: #000;
        position: absolute;
        left: 44.5%;
        top: 37%;
        opacity: 0;
        color: #00cc00;
        -webkit-animation: fade 1s linear infinite;
        -webkit-border-radius: 50px;
        -webkit-box-shadow: 0 0 3px rgba(0,0,0,0.2);
      }

        div.spinner div.bar1 {
          -webkit-transform: rotate(0deg) translate(0, -142%);
          -webkit-animation-delay: 0s;
        }

        div.spinner div.bar2 {
          -webkit-transform: rotate(30deg) translate(0, -142%);
          -webkit-animation-delay: -0.9167s;
        }

        div.spinner div.bar3 {
          -webkit-transform: rotate(60deg) translate(0, -142%);
          -webkit-animation-delay: -0.833s;
        }

        div.spinner div.bar4 {
          -webkit-transform: rotate(90deg) translate(0, -142%);
          -webkit-animation-delay: -0.75s;
        }

        div.spinner div.bar5 {
          -webkit-transform: rotate(120deg) translate(0, -142%);
          -webkit-animation-delay: -0.667s;
        }

        div.spinner div.bar6 {
          -webkit-transform: rotate(150deg) translate(0, -142%);
          -webkit-animation-delay: -0.5833s;
        }

        div.spinner div.bar7 {
          -webkit-transform: rotate(180deg) translate(0, -142%);
          -webkit-animation-delay: -0.5s;
        }

        div.spinner div.bar8 {
          -webkit-transform: rotate(210deg) translate(0, -142%);
          -webkit-animation-delay: -0.41667s;
        }

        div.spinner div.bar9 {
          -webkit-transform: rotate(240deg) translate(0, -142%);
          -webkit-animation-delay: -0.333s;
        }

        div.spinner div.bar10 {
          -webkit-transform: rotate(270deg) translate(0, -142%);
          -webkit-animation-delay: -0.25s;
        }

        div.spinner div.bar11 {
          -webkit-transform: rotate(300deg) translate(0, -142%);
          -webkit-animation-delay: -0.1667s;
        }

        div.spinner div.bar12 {
          -webkit-transform: rotate(330deg) translate(0, -142%);
          -webkit-animation-delay: -0.0833s;
        }

    @-webkit-keyframes fade {
      from {
        opacity: 1;
      }

      to {
        opacity: 0.25;
      }
    }

    /* end basic spinner styles*/

    /*div.container {
      display: inline-block;
      padding: 1.5em 1.5em 1.25em;
      background: rgba(0,0,0,0.8);
      -webkit-box-shadow: 1px 1px 1px #fff;
      -webkit-border-radius: 1em;
      margin: 1em;
    }*/

    /*div.container.grey {
        background: rgba(0,0,0,0.2);
      }*/

    div.container.grey.blue {
      background: -webkit-gradient(linear, left top, left bottom, color-stop(0, #0a2744), color-stop(1, #064483));
    }

    div.container div.spinner {
      width: 28px;
      height: 28px;
    }

    div.container.grey div.spinner {
      width: 60px;
      height: 60px;
    }

    div.container div.spinner div {
      background: #fff;
    }

    div.labeled {
      font-family: sans-serif;
      font-size: 14px;
      margin: 0 auto;
      background: #fff;
      padding: 0.5em 0.75em 0.5em 0.5em;
      display: inline-block;
      color: #c00;
      line-height: 25px;
      -webkit-box-shadow: 0 0 3px rgba(0,0,0,0.4);
      -webkit-border-radius: 1em;
      background: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(1, #ccc));
    }

      div.labeled div.spinner {
        float: left;
        vertical-align: middle;
        width: 25px;
        height: 25px;
        margin-right: 0.5em;
      }

        div.labeled div.spinner div {
          background: #c00;
        }
  </style>
  <!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/5.2.0/css/bootstrap.min.css" />
  <link rel="stylesheet" href="https://cdn.datatables.net/1.13.4/css/dataTables.bootstrap5.min.css" />-->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@3.0.0-alpha2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-aFq/bzH65dt+w6FI2ooMVUpc+21e0SRygnTpmBvdBgSdnuTN7QbdgL+OapgHtvPp" crossorigin="anonymous" />
</head>
<body>
  <h3>Student Fee Details (All Years) {{GLBappFormStarEnd}}</h3>
  <div class="container">
    <!--<div *ngIf="loading!=''" class="cssload-container">
      <div class="cssload-speeding-wheel"></div>
    </div>
    <div *ngIf="loading!=''" class='fullscreenDiv'>
      <div class="center">Loading...Please Wait</div>
    </div>-->
    <mat-form-field appearance="standard">
      <label><b>Enter Enrolment No.</b></label>
      <input matInput (keyup)="applyFilter($event)" placeholder="" #input />
    </mat-form-field>
    <div *ngIf="PleaseInt ==1" class="labeled">
      <div class="spinner">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
        <div class="bar4"></div>
        <div class="bar5"></div>
        <div class="bar6"></div>
        <div class="bar7"></div>
        <div class="bar8"></div>
        <div class="bar9"></div>
        <div class="bar10"></div>
        <div class="bar11"></div>
        <div class="bar12"></div>
      </div>
      {{ pleaseWait }}
    </div>
    <div class="export-container">
      <!--<button mat-raised-button color="primary" (click)="createPdf()">Export 1</button>-->
      <!--<button mat-raised-button color="primary" (click)="createPdfN()">Export 2</button>-->
      <button mat-raised-button color="primary" (click)="createPdfN()">Export (PDF)</button>
    </div>
    <div class="mat-elevation-z8">
      <div class="cf" id="pdfTable" #pdfTable>
        <h3>{{this.Year2023}}</h3>
        <table id="ExampleTable" mat-table [dataSource]="dataSource2023" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="admno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolment# </th>
            <!--<td mat-cell *matCellDef="let element"> {{element.admno}} </td>-->
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.admno}}  </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.name + element.leftDate}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.name}} </td>-->
          </ng-container>
          <ng-container matColumnDef="course">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Course </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.course}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.course}} </td>-->
          </ng-container>
          <ng-container matColumnDef="detail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Detail </th>
            <td mat-cell *matCellDef="let element"> {{element.detail}} </td>
          </ng-container>
          <ng-container matColumnDef="dues">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dues </th>
            <td mat-cell *matCellDef="let element"> {{element.dues}} </td>
          </ng-container>
          <ng-container matColumnDef="fees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.fees}} </td>
          </ng-container>
          <ng-container matColumnDef="feepaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee Paid </th>
            <td mat-cell *matCellDef="let element"> {{element.feepaid}} </td>
          </ng-container>
          <ng-container matColumnDef="adjustment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Adjust </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustment}} </td>
          </ng-container>
          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bal.Amt </th>
            <td mat-cell *matCellDef="let element"> {{element.balance}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row [ngClass]="{'make-gold': row.detail == 'C/Bal'}" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <h3>{{this.Year2024}}</h3>
        <table id="ExampleTable" mat-table [dataSource]="dataSource2024" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="admno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolment# </th>
            <!--<td mat-cell *matCellDef="let element"> {{element.admno}} </td>-->
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.admno}}  </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.name + element.leftDate}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.name}} </td>-->
          </ng-container>
          <ng-container matColumnDef="course">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Course </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.course}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.course}} </td>-->
          </ng-container>
          <ng-container matColumnDef="detail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Detail </th>
            <td mat-cell *matCellDef="let element"> {{element.detail}} </td>
          </ng-container>
          <ng-container matColumnDef="dues">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dues </th>
            <td mat-cell *matCellDef="let element"> {{element.dues}} </td>
          </ng-container>
          <ng-container matColumnDef="fees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.fees}} </td>
          </ng-container>
          <ng-container matColumnDef="feepaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee Paid </th>
            <td mat-cell *matCellDef="let element"> {{element.feepaid}} </td>
          </ng-container>
          <ng-container matColumnDef="adjustment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Adjust </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustment}} </td>
          </ng-container>
          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bal.Amt </th>
            <td mat-cell *matCellDef="let element"> {{element.balance}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row [ngClass]="{'make-gold': row.detail == 'C/Bal'}" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <h3>{{this.Year2025}}</h3>
        <table id="ExampleTable" mat-table [dataSource]="dataSource2025" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="admno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolment# </th>
            <!--<td mat-cell *matCellDef="let element"> {{element.admno}} </td>-->
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.admno}}  </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.name + element.leftDate}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.name}} </td>-->
          </ng-container>
          <ng-container matColumnDef="course">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Course </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.course}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.course}} </td>-->
          </ng-container>
          <ng-container matColumnDef="detail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Detail </th>
            <td mat-cell *matCellDef="let element"> {{element.detail}} </td>
          </ng-container>
          <ng-container matColumnDef="dues">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dues </th>
            <td mat-cell *matCellDef="let element"> {{element.dues}} </td>
          </ng-container>
          <ng-container matColumnDef="fees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.fees}} </td>
          </ng-container>
          <ng-container matColumnDef="feepaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee Paid </th>
            <td mat-cell *matCellDef="let element"> {{element.feepaid}} </td>
          </ng-container>
          <ng-container matColumnDef="adjustment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Adjust </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustment}} </td>
          </ng-container>
          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bal.Amt </th>
            <td mat-cell *matCellDef="let element"> {{element.balance}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row [ngClass]="{'make-gold': row.detail == 'C/Bal'}" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
                <h3>{{this.Year2026}}</h3>
        <table id="ExampleTable" mat-table [dataSource]="dataSource2026" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="admno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolment# </th>
            <!--<td mat-cell *matCellDef="let element"> {{element.admno}} </td>-->
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.admno}}  </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.name + element.leftDate}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.name}} </td>-->
          </ng-container>
          <ng-container matColumnDef="course">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Course </th>
            <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.course}}  </td>
            <!--<td mat-cell *matCellDef="let element"> {{element.course}} </td>-->
          </ng-container>
          <ng-container matColumnDef="detail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Detail </th>
            <td mat-cell *matCellDef="let element"> {{element.detail}} </td>
          </ng-container>
          <ng-container matColumnDef="dues">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dues </th>
            <td mat-cell *matCellDef="let element"> {{element.dues}} </td>
          </ng-container>
          <ng-container matColumnDef="fees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.fees}} </td>
          </ng-container>
          <ng-container matColumnDef="feepaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee Paid </th>
            <td mat-cell *matCellDef="let element"> {{element.feepaid}} </td>
          </ng-container>
          <ng-container matColumnDef="adjustment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Adjust </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustment}} </td>
          </ng-container>
          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bal.Amt </th>
            <td mat-cell *matCellDef="let element"> {{element.balance}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row [ngClass]="{'make-gold': row.detail == 'C/Bal'}" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!--<table id="ExampleTable" mat-table [dataSource]="dataSourcesum" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="admno">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolment# </th>-->
        <!--<td mat-cell *matCellDef="let element"> {{element.admno}} </td>-->
        <!--<td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.admno}}  </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.name}}  </td>-->
        <!--<td mat-cell *matCellDef="let element"> {{element.name}} </td>-->
        <!--</ng-container>
        <ng-container matColumnDef="course">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Course </th>
          <td mat-cell *matCellDef="let row; let element" [ngClass]="{'whitetext': row.detail == 'C/Bal' || row.rNo!=1,'boldtext': row.rNo==1 }"> {{element.course}}  </td>-->
        <!--<td mat-cell *matCellDef="let element"> {{element.course}} </td>-->
        <!--</ng-container>
          <ng-container matColumnDef="detail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Detail </th>
            <td mat-cell *matCellDef="let element"> {{element.detail}} </td>
          </ng-container>
          <ng-container matColumnDef="dues">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dues </th>
            <td mat-cell *matCellDef="let element"> {{element.dues}} </td>
          </ng-container>
          <ng-container matColumnDef="fees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.fees}} </td>
          </ng-container>
          <ng-container matColumnDef="feepaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee Paid </th>
            <td mat-cell *matCellDef="let element"> {{element.feepaid}} </td>
          </ng-container>
          <ng-container matColumnDef="adjustment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Adjust </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustment}} </td>
          </ng-container>
          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bal.Amt </th>
            <td mat-cell *matCellDef="let element"> {{element.balance}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row [ngClass]="{'make-gold': row.detail == 'C/Bal'}" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>-->
        <!--<form>
          <div *ngIf="StudentDetAll[0].admno != ''"><button style="background-color: red; color: white; border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;" tabindex="3" type="submit" name="deletefee" (click)="DeleteStudentFeeTran(StudentDetAll[0].admno,StudentDetAll[0].yearcode)">Delete All</button></div>
        </form>-->
      </div>
      <h4>Balance Fee Payable:{{this.totalBal}}</h4>
      <h4>{{this.AmountRs}}</h4>
      <!--<mat-paginator [pageSizeOptions]="[50, 100, 150, 200, 250, 300, 350]" showFirstLastButtons=showFirstLastButtons></mat-paginator>-->
    </div>
  </div>
</body>
</html>
